export const formatFlightDate = (date) => {
  // NOTE // output: 17AUG2021, input: 2021-08-17
  let day = date.slice(8, 10)
  let month = date.slice(5, 7)
  let year = date.slice(0, 4)
  let monthsArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  month = monthsArr[Number(month) - 1]
  return `${day + month + year}`
}